export const ACTION = {
  SET_NEW_STREAK: 'SET_NEW_STREAK',
  UPDATE_UNIT_STREAK_STATE: 'UPDATE_UNIT_STREAK_STATE',
  UPDATE_LONGEST_STREAK_STATE: 'UPDATE_LONGEST_STREAK_STATE',
};

export const LONGEST_STREAK_STATE = {
  INACTIVE: 'INACTIVE',
  ACTIVE: 'ACTIVE',
  PLAY: 'PLAY',
};

export const UNIT_STREAK_STATE = {
  NEUTRAL: 'NEUTRAL',
  STREAK: 'STREAK',
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL',
};

export const INITIAL_STATE = {
  current: 0,
  longest: 0,
  unitStreaks: [
    {index: 1, state: UNIT_STREAK_STATE.NEUTRAL},
    {index: 2, state: UNIT_STREAK_STATE.NEUTRAL},
    {index: 3, state: UNIT_STREAK_STATE.NEUTRAL},
    {index: 4, state: UNIT_STREAK_STATE.NEUTRAL},
    {index: 5, state: UNIT_STREAK_STATE.NEUTRAL},
    {index: 6, state: UNIT_STREAK_STATE.NEUTRAL},
    {index: 7, state: UNIT_STREAK_STATE.NEUTRAL},
    {index: 8, state: UNIT_STREAK_STATE.NEUTRAL},
  ],
  longestStreak: LONGEST_STREAK_STATE.INACTIVE,
};

export function StreakReducer(state, action) {
  switch (action.type) {
    case ACTION.SET_NEW_STREAK:
      return setNewStreak(state, action.payload);
    case ACTION.UPDATE_UNIT_STREAK_STATE:
      return updateUnitStreakStatus(state);
    case ACTION.UPDATE_LONGEST_STREAK_STATE:
      return handleUpdateLongestStreakState(state, action.payload);
    default:
      return state;
  }
}

function setNewStreak(state, payload) {
  let current = payload.currentStreak;
  let longest = payload.longestStreak;
  let unitStreaks = updateUnitStreakList(
    state.unitStreaks,
    current,
    current === longest,
    payload.isLatestOperationCorrect
  );
  let longestStreak = getNewLongestStreak(longest, unitStreaks);
  if (
    hasNoFailSteakStatusOnError(unitStreaks, payload.isLatestOperationCorrect)
  ) {
    unitStreaks = getNewListOfUnitSteaks(0);
  }
  return {...state, current, longest, unitStreaks, longestStreak};
}

function updateUnitStreakList(
  unitStreakList,
  current,
  isLongest,
  isLastOperationCorrect
) {
  return unitStreakList.map((item) => {
    if (isLastOperationCorrect) {
      if (item.index < current) {
        return {...item, state: UNIT_STREAK_STATE.SUCCESS};
      } else if (item.index === current && item.index === 1) {
        return {...item, state: UNIT_STREAK_STATE.SUCCESS};
      } else if (item.index === current) {
        if (isLongest) {
          return {...item, state: UNIT_STREAK_STATE.STREAK};
        } else {
          return {...item, state: UNIT_STREAK_STATE.SUCCESS};
        }
      } else {
        return {...item};
      }
    } else {
      if (item.state !== UNIT_STREAK_STATE.NEUTRAL) {
        return {...item, state: UNIT_STREAK_STATE.FAIL};
      } else {
        return {...item};
      }
    }
  });
}

function checkAllUnitSteaksSuccess(unitStreaks) {
  return unitStreaks.every(
    (item) =>
      item.state === UNIT_STREAK_STATE.SUCCESS ||
      item.state === UNIT_STREAK_STATE.STREAK
  );
}

function getNewLongestStreak(longest, unitStreaks) {
  let longestStreak = LONGEST_STREAK_STATE.INACTIVE;
  if (longest >= 1) {
    longestStreak = LONGEST_STREAK_STATE.ACTIVE;
  }
  const isSuccess = checkAllUnitSteaksSuccess(unitStreaks);
  if (isSuccess) {
    longestStreak = LONGEST_STREAK_STATE.PLAY;
  }
  return longestStreak;
}

// The action is particularly throttled in component <StreakList /> to be
// invoked only once to prevent side effects.
function updateUnitStreakStatus(state) {
  let unitStreaks = JSON.parse(JSON.stringify(INITIAL_STATE.unitStreaks));
  return {...state, unitStreaks};
}

function handleUpdateLongestStreakState(state, payload) {
  let unitStreaks = getNewListOfUnitSteaks(state.current);
  let longestStreak = payload;
  return {...state, unitStreaks, longestStreak};
}

function getNewListOfUnitSteaks(startIndex) {
  let unitStreaks = JSON.parse(JSON.stringify(INITIAL_STATE.unitStreaks));
  return unitStreaks.map((item) => {
    return {...item, index: startIndex + item.index};
  });
}

function hasNoFailSteakStatusOnError(unitStreaks, isLastOperationCorrect) {
  if (isLastOperationCorrect) {
    return false;
  } else {
    return !unitStreaks.some(
      (streakItem) => streakItem.state === UNIT_STREAK_STATE.FAIL
    );
  }
}
